import { IPFS_URL } from '../../app/constants'

export const SpecialCard = ({
  name,
  image,
  video,
  quantity,
  mp,
  notInUserWallet,
  templateId,
}) => {
  return (
    <div className="flex flex-col gap-2">
      <div
        className={
          notInUserWallet ? 'col-span-2 filter grayscale ' : 'col-span-2'
        }
      >
        {video ? (
          <video
            className="border border-cyanBlue"
            autoPlay
            loop
            muted
            src={`${IPFS_URL}${video}`}
          ></video>
        ) : (
          <img
            className="border border-cyanBlue"
            alt={name}
            // src={`${IPFS_URL}${image}`} // Switch why added static data
            src={image}
            loading="lazy"
          ></img>
        )}
      </div>
      <div>
        {/* <h3 className='text-white pt-3'>{name}</h3> */}
        {!notInUserWallet && (
          <dl>
            <dt className="text-gold inline-block w-fit">Total: </dt>
            <dd className="text-white inline-block pl-1">{quantity}</dd>
            <br />
            <dt className="text-gold inline-block w-fit">Total MP:</dt>
            <dd className="text-white inline-block pl-1">{mp * quantity}</dd>
          </dl>
        )}

        <div className="text-cyanBlue">
          <a
            href={`https://wax.atomichub.io/market?collection_name=galaktikanft&match=${templateId}&order=desc&sort=created&symbol=WAX`}
            target="_blank"
            rel="noreferrer"
          >
            Trade
          </a>
        </div>
      </div>
    </div>
  )
}
